import { Component, Input } from '@angular/core';
import { FilterItemComponent } from '../../filter-item/filter-item.component';

@Component({
  selector: 'app-schedule-filter',
  templateUrl: './schedule-filter.component.html',
  styleUrls: [
    '../../filter-item/filter-item.component.scss',
    './schedule-filter.component.scss'
  ]
})
export class ScheduleFilterComponent extends FilterItemComponent {
  @Input({ required: true }) applyFilterBtnText: string = ""; 
}
